
import { Options, setup, Vue } from "vue-class-component";
import { computed, defineAsyncComponent } from "vue";
import { useStore } from "vuex";
import { key } from "@/store";

import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faEye,
  faStar,
  faBell,
  faPhone,
  faCaretDown,
  faCaretUp,
  faCaretRight
} from "@fortawesome/free-solid-svg-icons";
import { useMeta } from "vue-meta";

library.add( faEye, faStar, faBell, faPhone, faCaretDown, faCaretUp, faCaretRight );

import { Bar, Doughnut } from "vue-chartjs";
import { Chart as ChartJS, Title, Tooltip, Legend, ArcElement, BarElement, CategoryScale, LinearScale } from "chart.js";

ChartJS.register( Title, Tooltip, ArcElement, Legend, BarElement, CategoryScale, LinearScale );

@Options( {
  props      : {
    tarif : Boolean,
    title : String,
    desc  : String
  },
  components : {
    Bar,
    FontAwesomeIcon,
    Header      : defineAsyncComponent( () => import("../components/Header.vue" ) ),
    Footer      : defineAsyncComponent( () => import("../components/Footer.vue" ) ),
    Loader      : defineAsyncComponent( () => import("../components/Loader.vue" ) ),
    Map         : defineAsyncComponent( () => import("../components/Map.vue") ),
    SearchBar   : defineAsyncComponent( () => import("../components/SearchBar.vue") ),
    Actions     : defineAsyncComponent( () => import("../components/Search/Actions.vue") ),
    CalculModal : defineAsyncComponent( () => import("../components/Search/CalculModal.vue") )
  }
} )
export default class extends Vue
{
  store         = useStore( key );
  map_shown     = false;
  window        = window;
  sentence_open = false;
  desc_open     = false;
  gm_start      = 0;
  gm_per_page   = 10;
  pages         = 0;
  search_string = "";
  props         = Object.assign( {}, ... Object.entries( this.$props ).map( ( [key, value] ) => ({ [key] : value }) ) );

  filters_shown = false;
  filters       = {
    size   : "all",
    type   : "all",
    carton : "all",
    promo  : "all"
  };

  opened_faqs = [];

  charts : any = null;

  TOOLTIP_PROMO   = "Cet établissement offre des promotions sur les box !";
  TOOLTIP_PRICE   = "Cet établissement offre des prix en ligne. Les tarifs sont clairement sur le site. La réservation d'un box de stockage est gratuite en ligne et sans obligation. Aucun numéro de carte de crédit ne vous sera demandé.";
  TOOLTIP_STUDENT = "Cet établissement offre des tarifs spéciaux pour les étudiants. Le prix étudiant est indiqué clairement sur les box concernés.";
  TOOLTIP_TOP50   = "Ce centre de stockage fait partie de notre programme de partenariat de garde meubles préférés. Ceux-ci se distinguent notamment par leurs excellents services et rapport qualité prix ainsi que leurs tarifs compétitifs. La participation de ce centre de location de box dépend de certain critères précis : accueil, propreté, accès, sécurité… et prend également en compte les retours de ses clients.";
  TOOLTIP_CAMION  = "Cet établissement propose sur place une prestation de transport pour vos affaires. Cela peut-être un déménageur qualifié avec un camion de déménagement, une location simple de camion ou une location de camion avec chauffeur.";

  meta = setup( () => useMeta( computed( () => {
    if( this.store.state.search == null )
      return {};
    else
    {
      if( this.props.tarif )
      {
        return {
          title       : [{
            content : "Tarif garde meuble " + this.store.state.search.city.name + " " + this.store.state.search.city.postcode + ". Prix m2 de " + this.store.state.search.near.length + " box à louer",
            vmid    : "title",
            name    : "title"
          }],
          description : {
            content : "Prix réel garde meuble " + this.store.state.search.city.name + " " + this.store.state.search.city.postcode + " et box de self stockage. Consultez les tarifs garde meubles " + new Date().getFullYear() + "/" + (new Date().getFullYear() + 1) + " - " + this.store.state.search.near.length * 2 + " box de stockage à louer",
            vmid    : "description",
            name    : "description"
          }
        };
      } else
      {
        return {
          title       : [{
            content : "Garde meuble " + this.store.state.search.city.name + " " + this.store.state.search.city.postcode + " - " + this.store.state.search.near.length + " box de stockage à louer",
            vmid    : "title",
            name    : "title"
          }],
          description :
            {
              content : "Trouver un garde meuble " + this.store.state.search.city.name + " " + this.store.state.search.city.postcode + ". Location de box " + this.store.state.search.city.name + ". Louez un stockage pas cher près de chez vous." + " - " + this.store.state.search.near.length * 2 + " box de stockage à louer",
              vmid    : "description",
              name    : "description"
            }
        };
      }
    }
  } ) ) );

  getAverageRatingForAllResults()
  {
    const gmWithNote = this.store.state.search.near.filter( ( gm : any ) => gm.note > 0 );
    return this.store.state.search.near.reduce( ( acc : number, gm : any ) => acc + gm.note, 0 ) / gmWithNote.length;
  }

  getBestRatingForAllResults()
  {
    const gmWithNote = this.store.state.search.near.filter( ( gm : any ) => gm.note > 0 );
    return gmWithNote.reduce( ( acc : number, gm : any ) => Math.max( acc, gm.note ), 0 );
  }

  getWorstRatingForAllResults()
  {
    const gmWithNote = this.store.state.search.near.filter( ( gm : any ) => gm.note > 0 );
    return gmWithNote.reduce( ( acc : number, gm : any ) => Math.min( acc, gm.note ), 5 );
  }

  getTotalAvisForAllResults()
  {
    return this.store.state.search.near.reduce( ( acc : number, gm : any ) => acc + gm.avis.length, 0 );
  }

  getMonth()
  {
    let objDate = new Date();
    let month   = objDate.toLocaleString( "fr-fr", { month : "long" } );
    return month.charAt( 0 ).toUpperCase() + month.slice( 1 );
  }

  getMonthYear()
  {
    let objDate = new Date();
    let month   = objDate.toLocaleString( "fr-fr", { month : "long" } );
    return month.charAt( 0 ).toUpperCase() + month.slice( 1 ) + " " + objDate.getFullYear();
  }

  filtersActive()
  {
    return this.filters.size !== "all" || this.filters.type !== "all" || this.filters.carton !== "all" || this.filters.promo !== "all";
  }

  getFilteredResults()
  {
    let results = this.store.state.search.near;

    if( this.filters.size !== "all" )
      results = results.filter( ( gm : any ) => {

        if( !gm.size_range.all )
        {
          // create size array from min and max
          gm.size_range.all = [];
          for( let i = gm.size_range.min; i <= gm.size_range.max; i++ )
            gm.size_range.all.push( i );
        }

        let min = Number(this.filters.size.split( "-" )[0]);
        let max = Number(this.filters.size.split( "-" )[1]);

        // if gm.size_range.all array has a number between min and max, return true
        return gm.size_range.all.some( ( size : number ) => size >= min && size <= max );
      } );

    if( this.filters.type !== "all" )
      results = results.filter( ( gm : any ) => {
        if( this.filters.type === "indoor" )
          return [ "Garde meubles", "Self Stockage" ].includes( gm.type );
        else if( this.filters.type === "outdoor" )
          return [ "Déménageur", "Container self-stockage" ].includes( gm.type );
      } );

    if( this.filters.carton !== "all" )
      results = results.filter( ( gm : any ) => true ); // TODO : Currently no way to know

    if( this.filters.promo !== "all" )
      results = results.filter( ( gm : any ) => gm.has_promo );


    // TODO : Check pagination impact
    // this.pages = Math.ceil( results.length / this.gm_per_page );

    return results;
  }

  getPriceChartData()
  {
    if( this.store.state.search == null )
      return [0, 0, 0];

    return [
      this.store.state.search.mensuel?.moyenne ?? 0,
      this.store.state.search.departement?.price ?? 0,
      this.store.state.search.region?.price ?? 0
    ];
  }

  getCityNameOrDefault()
  {
    return this.store.state.search?.city?.name ?? "Ville";
  }

  getDepartementNameOrDefault()
  {

    return ("Département - " + this.store.state.search?.departement?.name).trim();
  }

  getRegionNameOrDefault()
  {
    return ("Région - " + this.store.state.search?.region?.name).trim();
  }

  mounted()
  {
    this.generateSearchString();

    // Hide loader if page content has preloaded
    let preload = document.getElementById( "preload" );
    if( preload )
      this.store.state.loading = false;

    let headers = new Headers();

    const city     = typeof this.$route.params.city !== "undefined" ? this.$route.params.city : "Paris";
    const postcode = typeof this.$route.params.postcode !== "undefined" ? this.$route.params.postcode : "75000";

    console.log(this.props.tarif ?? false ? "1" : "0");

    fetch( this.store.state.apiVue + "search/" + city + "/" + postcode + "/" + (this.props.tarif ?? false ? "1" : "0"), {
      method  : "GET",
      headers : headers,
      cache   : "no-cache"
    } ).then( ( res ) => {
      return res.json();
    } ).then( ( json ) => {
      if( typeof json.error !== "undefined" )
      {
        this.store.state.error = "Une erreur est survenue lors du chargement de la page (Error " + json.error + ")";
      } else
      {
        // Redirect 301 to real URL
        if( ("https://www.location-gardemeuble.fr" + this.$route.path) != (this.props.tarif ? json.data.city.url_t : json.data.city.url) )
        {
          window.location.replace( json.data.city.url.replace( "https://www.location-gardemeuble.fr/", this.store.state.base_url ) );
          return;
        }

        this.store.state.search = json.data;

        this.charts = {
          tarif : {
            data    : {
              labels   : this.getPriceChartLabels(),
              datasets : [
                {
                  data            : this.getPriceChartData(),
                  backgroundColor : [
                    "rgb(28,90,162)",
                    "rgb(242,159,26)",
                    "rgb(53,56,138)"
                  ]
                }
              ]
            },
            options : {
              animations          : false,
              indexAxis           : "x",
              scales              : {
                x : {
                  ticks : {
                    color           : "black",
                    font            : {
                      size : 13
                    },
                    autoSkip        : false,
                    autoSkipPadding : false
                  },
                  grid  : {
                    display : false
                  }
                }
              },
              plugins             : {
                legend  : {
                  display : false
                },
                tooltip : {
                  callbacks : {
                    label : ( item : any ) =>
                      `Prix : ${item.formattedValue} € / m² en moyenne`
                  }
                }
              },
              responsive          : true,
              maintainAspectRatio : false
            }
          },
          date  : {
            data    : {
              labels   : this.getDateChartLabels(),
              datasets : [
                {
                  data            : this.getDateChartData(),
                  backgroundColor : [
                    "rgb(28,90,162)"
                  ]
                }
              ]
            },
            options : {
              animations          : false,
              indexAxis           : "x",
              scales              : {
                x : {
                  ticks : {
                    color           : "black",
                    font            : {
                      size : 13
                    },
                    autoSkip        : false,
                    autoSkipPadding : false
                  },
                  grid  : {
                    display : false
                  }
                }
              },
              plugins             : {
                legend  : {
                  display : false
                },
                tooltip : {
                  callbacks : {
                    label : ( item : any ) =>
                      `${item.formattedValue}% des demandes`
                  }
                }
              },
              responsive          : true,
              maintainAspectRatio : false
            }
          },
          date_demande  : {
            data    : {
              labels   : this.getDateChartLabels(),
              datasets : [
                {
                  data            : this.getDateDemandeChartData(),
                  backgroundColor : [
                    "rgb(242,159,26)"
                  ]
                }
              ]
            },
            options : {
              animations          : false,
              indexAxis           : "x",
              scales              : {
                x : {
                  ticks : {
                    color           : "black",
                    font            : {
                      size : 13
                    },
                    autoSkip        : false,
                    autoSkipPadding : false
                  },
                  grid  : {
                    display : false
                  }
                }
              },
              plugins             : {
                legend  : {
                  display : false
                },
                tooltip : {
                  callbacks : {
                    label : ( item : any ) =>
                      `${item.formattedValue}% des demandes`
                  }
                }
              },
              responsive          : true,
              maintainAspectRatio : false
            }
          },
          size_demande  : {
            data    : {
              labels   : this.getDateChartLabels(),
              datasets : [
                {
                  data            : this.getSizeDemandeChartData(),
                  backgroundColor : [
                    "rgb(242,159,26)"
                  ]
                }
              ]
            },
            options : {
              animations          : false,
              indexAxis           : "x",
              scales              : {
                x : {
                  ticks : {
                    color           : "black",
                    font            : {
                      size : 13
                    },
                    autoSkip        : false,
                    autoSkipPadding : false
                  },
                  grid  : {
                    display : false
                  }
                }
              },
              plugins             : {
                legend  : {
                  display : false
                },
                tooltip : {
                  callbacks : {
                    label : ( item : any ) =>
                      `${item.formattedValue} m²`
                  }
                }
              },
              responsive          : true,
              maintainAspectRatio : false
            }
          },
        };

        // for each gm, increment search counter
        this.store.state.search.near.forEach( ( gm : any ) => {
          this.store.state.counter( "search", gm.id, () => "" );
        } );

        this.pages = Math.ceil( this.store.state.search.near.length / this.gm_per_page );
        setTimeout( () => {
          this.store.state.loading = false;

          // Remove div#preload from DOM
          let preload = document.getElementById( "preload" );
          if( preload )
          {
            window.scrollTo( { top : 0 } );
            preload.remove();
          }
        }, this.store.state.delay );
      }
    } ).catch( error => {
      this.store.state.loading = false;
      console.error( error );
    } );
  }

  boxPriceLowest()
  {
    let key = Number( Object.keys( this.store.state.search.mensuel )[0] );

    for( key = 0 ; key < Object.keys( this.store.state.search.mensuel ).length ; key++ )
      if( typeof this.store.state.search.mensuel[key] !== "undefined" && key > 0 )
        break;

    return {
      size  : key,
      price : this.store.state.search?.mensuel[key]?.low ?? 0
    };
  }

  boxPriceHighest()
  {
    let key = Object.keys( this.store.state.search.mensuel )[15];

    if( typeof this.store.state.search.mensuel[key] === "undefined" )
      key = Object.keys( this.store.state.search.mensuel )[Object.keys( this.store.state.search.mensuel ).length - 2];

    if( typeof this.store.state.search.mensuel[key] === "undefined" )
      key = Object.keys( this.store.state.search.mensuel )[Object.keys( this.store.state.search.mensuel ).length - 1];

    return {
      size  : key,
      price : this.store.state.search?.mensuel[key]?.up ?? 0
    };
  }

  boxBiggest()
  {
    let key = Object.keys( this.store.state.search.mensuel )[Object.keys( this.store.state.search.mensuel ).length - 2];

    return {
      size  : key,
      price : this.store.state.search?.mensuel[key]?.up ?? 0
    };
  }

  private generateSearchString()
  {
    if( this.$route.params.city )
    {
      this.search_string += this.$route.params.city;
      this.search_string += "-";
    }

    if( this.$route.params.postcode )
    {
      this.search_string += this.$route.params.postcode;
    }

    this.search_string += "/" + (this.props.tarif ?? false ? "tarif" : "base");
  }

  private getPriceChartLabels()
  {
    return [this.getCityNameOrDefault(), this.getDepartementNameOrDefault(), this.getRegionNameOrDefault()];
  }

  private getDateChartLabels()
  {
    return ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  }

  private getDateChartData()
  {
    return this.store.state.search?.stats;
  }

  private getDateDemandeChartData()
  {
    return this.store.state.search?.stats_demande;
  }

  private getSizeDemandeChartData()
  {
    return this.store.state.search?.stats_size;
  }

  private getMonthDemande( max = true )
  {
    // copy this.store.state.search.stats_demande object and sort properties by value desc
    let stats = Object.assign( {}, this.store.state.search.stats_demande );
    let sorted = Object.keys( stats ).sort( ( a, b ) => stats[b] - stats[a] );

    return max ? sorted[0] : sorted[sorted.length - 1];
  }

  private getMonthSize()
  {
    // get this.store.state.search.stats_size[this.getMonth()] with null checks
    return this.store.state.search?.stats_size[this.getMonth()] ?? 0;
  }

  boxes( boxes : any )
  {
    return boxes.filter( ( box : any ) => typeof box.available === 'undefined' || box.available > 0 );
  }
}
